
import { useState } from 'react';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import ServiceSection from './components/ServiceSection';
import ResultsSection from './components/ResultsSection';
import StepsSection from './components/StepsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <ProblemSection />
      <ServiceSection />
      <ResultsSection />
      <StepsSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
    </div>
  );
}
